import { ReadonlyMat3, vec3 } from 'gl-matrix';

/**
 * Compute the deviation in degrees of a slice's normal vector
 * from the closest principal patient axis. Returns 0 for axis-
 * aligned (axial / coronal / sagittal) acquisitions and the
 * deviation angle for oblique ones.
 *
 * Uses the convention that the slice normal lives in the third
 * column of the orientation matrix (matching DicomImageSlice and
 * Grid in this project).
 */
export function obliquityAngleDeg(orientation: ReadonlyMat3): number {
    // Slice normal = column 2 of the column-major mat3.
    const normal = vec3.fromValues(
        orientation[6],
        orientation[7],
        orientation[8]
    );
    const maxAbsDot = Math.max(
        Math.abs(normal[0]),
        Math.abs(normal[1]),
        Math.abs(normal[2])
    );
    // Clamp before acos to guard against tiny FP excursions past 1.
    const clamped = Math.min(1, Math.max(-1, maxAbsDot));
    return (Math.acos(clamped) * 180) / Math.PI;
}
